const print = {
    svg: '<svg style="width:1.00rem; height:0.88rem;" viewBox="0 0 16 14"><path d="M13.6 4.89H2.4A2.36 2.36 0 0 0 0 7.22v4.67h3.2V15h9.6v-3.11H16V7.22a2.36 2.36 0 0 0-2.4-2.33m-2.4 8.55H4.8V9.56h6.4zM13.6 8a.8.8 0 1 1 0-1.6.8.8 0 0 1 0 1.6m-.8-7H3.2v3.11h9.6z"/></svg>',
};

export { print as default };
